import moment from "moment";
import "moment/locale/es";
moment.locale("es");

/**
 * PDF de la Solicitud de Cotizacion que se manda a un proveedor a partir de una Requisicion.
 *
 * Gemelo de erp_backend/Pdf/solicitudCotizacionPdf.js (mismo contenido, ESM en vez de CJS).
 * El frontend lo usa para la vista previa y la descarga; el backend, para adjuntarlo al correo.
 */
const solicitudCotizacionPdf = (data) => {
    const empresa = data.empresa || {};
    const logoEmpresa = empresa.logo?.base64Completa || "";
    const logoBiwo = data.logoBiwo?.base64Completa || "";
    const dato = data.data || {};
    const requisicion = data.requisicion || {};
    const proveedor = data.proveedor || null;
    const usuario = data.usuario || {};
    const proyecto = data.proyecto || {};
    const insumos = data.insumos || [];
    const observaciones = data.observaciones || "";
    const vigencia = data.vigencia;

    // Renglon en blanco con linea, para lo que el proveedor llena a mano
    const lineaEnBlanco = {
        text: " ",
        style: "textoChico",
        border: [false, false, false, true],
    };

    return {
        footer: { image: "logoBiwo", alignment: "center", width: 50 },
        content: [
            {
                style: "tableExample",
                table: {
                    widths: ["18%", "52%", "30%"],
                    layout: { defaultBorder: false },
                    body: [
                        [
                            {
                                border: [false, false, false, false],
                                image: "logo",
                                fit: [80, 80]
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ["100%"],
                                    body: [
                                        [{ text: empresa.nombreComercial ? empresa.nombreComercial : empresa.nombre || "Nombre Empresa", style: "tableHeader" }],
                                        [
                                            {
                                                text: `R.F.C: ${empresa.rfc || "N/A"}`,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.calle ? `${empresa.calle} ${empresa.numeroCalle || ""}` : "Dirección N/A",
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.colonia?.nombre
                                                    ? `${empresa.colonia.nombre} C.P. ${empresa.colonia.cp || "N/A"}`
                                                    : "Colonia N/A",
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [{ text: "SOLICITUD DE COTIZACION", style: "tableHeader" }]
                                    ]
                                },
                                layout: "noBorders"
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ["100%"],
                                    body: [
                                        [
                                            {
                                                text: dato.numero ? "N° SOLICITUD:" : "N° REQUISICION:",
                                                style: "subheader",
                                                alignment: "center"
                                            }
                                        ],
                                        [
                                            {
                                                text: dato.numero ? dato.numero : (requisicion.numero || ""),
                                                style: "textoChico",
                                                alignment: "center"
                                            }
                                        ],
                                    ]
                                },
                                layout: "noBorders"
                            }
                        ]
                    ]
                }
            },
            // Bloque de proveedor: con datos si se selecciono, o en blanco para llenar a mano
            {
                style: "tableExample",
                table: {
                    widths: ["18%", "82%"],
                    body: [
                        [
                            { text: "Proveedor:", style: "subheader", border: [false, false, false, false] },
                            proveedor
                                ? { text: proveedor.nombre || "", style: "textoChico", border: [false, false, false, true] }
                                : lineaEnBlanco,
                        ],
                        [
                            { text: "R.F.C:", style: "subheader", border: [false, false, false, false] },
                            proveedor
                                ? { text: proveedor.rfc || "", style: "textoChico", border: [false, false, false, true] }
                                : lineaEnBlanco,
                        ],
                    ],
                },
            },
            {
                style: "tableExample",
                table: {
                    widths: ["100%"],
                    layout: { defaultBorder: false },
                    body: [
                        [
                            {
                                table: {
                                    widths: ["25%", "75%"],
                                    layout: { defaultBorder: false },
                                    body: [
                                        [
                                            { text: "Requisición:", style: "subheader" },
                                            { text: requisicion.numero ? String(requisicion.numero) : "", style: "textoChico" },
                                        ],
                                        [
                                            { text: "Proyecto:", style: "subheader" },
                                            { text: (proyecto.nombre || "") + (proyecto.descripcion ? " - " + proyecto.descripcion : ""), style: "textoChico" },
                                        ],
                                        [
                                            { text: "Fecha:", style: "subheader" },
                                            { text: moment().format("DD [de] MMMM [de] YYYY"), style: "textoChico" },
                                        ],
                                        [
                                            { text: "Fecha de Entrega Requerida:", style: "subheader" },
                                            { text: requisicion.fechaEntrega ? moment(requisicion.fechaEntrega).format("DD [de] MMMM [de] YYYY") : "", style: "textoChico" },
                                        ],
                                        [
                                            { text: "Responder antes de:", style: "subheader" },
                                            { text: vigencia ? moment(vigencia).format("DD [de] MMMM [de] YYYY") : "", style: "textoChico" },
                                        ],
                                    ],
                                },
                                layout: "noBorders",
                            },
                        ],
                    ],
                },
            },
            {
                style: "tableExample",
                table: {
                    widths: ["9%", "11%", "9%", "39%", "16%", "16%"],
                    layout: { defaultBorder: true },
                    body: [
                        [
                            { text: "Cantidad", style: "tituloTabla" },
                            { text: "Clave Int.", style: "tituloTabla" },
                            { text: "Unidad", style: "tituloTabla" },
                            { text: "Descripción", style: "tituloTabla" },
                            { text: "Precio Unitario", style: "tituloTabla" },
                            { text: "Importe", style: "tituloTabla" },
                        ],
                        ...insumos.map((insumo) => [
                            { text: insumo.cantidad || "", style: "textoTabla", alignment: "center" },
                            { text: insumo.claveInt || "", style: "textoTabla", alignment: "center" },
                            { text: insumo.unidad || "", style: "textoTabla", alignment: "center" },
                            { text: (insumo.descripcion || "") + (insumo.observaciones ? ("\n" + insumo.observaciones) : ""), style: "textoTabla", alignment: "left" },
                            // En blanco: las llena el proveedor
                            { text: " ", style: "textoTabla" },
                            { text: " ", style: "textoTabla" },
                        ]),
                    ],
                },
            },
            observaciones
                ? {
                    style: "tableExample",
                    table: {
                        widths: ["18%", "82%"],
                        layout: { defaultBorder: false },
                        body: [
                            [
                                { text: "Observaciones:", style: "subheader" },
                                { text: observaciones, style: "textoChico" },
                            ],
                        ],
                    },
                    layout: "noBorders",
                }
                : { text: "" },
            // Datos comerciales que el proveedor completa
            {
                style: "tableExample",
                margin: [0, 10, 0, 0],
                table: {
                    widths: ["28%", "72%"],
                    body: [
                        [
                            { text: "Vigencia de la cotización:", style: "subheader", border: [false, false, false, false] },
                            lineaEnBlanco,
                        ],
                        [
                            { text: "Tiempo de entrega:", style: "subheader", border: [false, false, false, false] },
                            lineaEnBlanco,
                        ],
                        [
                            { text: "Condiciones de pago:", style: "subheader", border: [false, false, false, false] },
                            lineaEnBlanco,
                        ],
                    ],
                },
            },
            [
                {
                    style: 'tableExample', margin: [0, 40, 0, 0],
                    table: {
                        widths: ['35%', '30%', '35%'],
                        layout: {
                            defaultBorder: false,
                        },
                        body: [
                            [
                                { text: '', style: 'textoTabla', alignment: 'center' },
                                { text: `Responsable: ${usuario.nombre || ""} ${usuario.apellidoPaterno || ""} ${usuario.apellidoMaterno || ""}`, style: 'textoTabla', alignment: 'center', border: [false, true, false, false] },
                                { text: '', style: 'textoTabla', alignment: 'center' },
                            ],
                        ]
                    },
                    layout: {
                        defaultBorder: false,
                    }
                }
            ],
        ],
        images: {
            logo: logoEmpresa,
            logoBiwo: logoBiwo
        },
        styles: {
            header: { fontSize: 9, bold: true },
            subheader: { fontSize: 8, bold: true },
            tableExample: { margin: [0, 5, 0, 5] },
            tableHeader: { bold: true, fontSize: 12, alignment: "center" },
            textoChico: { fontSize: 8 },
            tituloTabla: {
                fontSize: 8,
                bold: true,
                fillColor: "#cccccc",
                alignment: "center",
            },
            textoTabla: { fontSize: 8 },
        },
        pageSize: "LETTER",
        pageMargins: [20, 20, 20, 20],
    };
};

export default solicitudCotizacionPdf;
